import { animate, animateMini, inView, stagger } from 'motion';

function initHeroEntrance() {
  const heroItems = document.querySelectorAll('.hero-eyebrow, .hero-headline, .hero-sub, .hero-ctas');
  if (!heroItems.length) return;

  animateMini(
    heroItems,
    { opacity: [0, 1], transform: ['translateY(18px)', 'translateY(0)'] },
    { duration: 0.7, delay: stagger(0.09), ease: [0.16, 1, 0.3, 1] }
  );
}

function initSectionReveals() {
  inView('.reveal', (element) => {
    if (element.classList.contains('hero') || element.classList.contains('work-card')) return;
    if ((element as HTMLElement).dataset.revealed) return;
    (element as HTMLElement).dataset.revealed = 'true';

    animateMini(
      element,
      { opacity: [0, 1], transform: ['translateY(28px)', 'translateY(0)'] },
      { duration: 0.72, ease: [0.16, 1, 0.3, 1] }
    );
  }, { margin: '0px 0px -16% 0px' });
}

function initStatsCounters() {
  inView('.stats-strip', (section) => {
    if ((section as HTMLElement).dataset.statsAnimated) return;
    (section as HTMLElement).dataset.statsAnimated = 'true';

    section.querySelectorAll<HTMLElement>('.stat-num').forEach((node) => {
      const target = Number(node.dataset.count ?? 0);
      const suffix = node.dataset.suffix ?? '';

      animate(0, [target], {
        duration: 1.1,
        ease: [0.16, 1, 0.3, 1],
        onUpdate: (latest) => {
          node.firstChild ? node.firstChild.textContent = `${Math.round(latest)}${suffix}` : node.prepend(`${Math.round(latest)}${suffix}`);
        }
      });
    });

    animateMini(
      section.querySelectorAll('.stat-bar'),
      { transform: ['scaleX(0)', 'scaleX(1)'] },
      { duration: 0.8, delay: stagger(0.08), ease: [0.16, 1, 0.3, 1] }
    );
  }, { margin: '0px 0px -20% 0px' });
}

function initWorkCardStagger() {
  inView('.work-grid', (grid) => {
    if ((grid as HTMLElement).dataset.workAnimated) return;
    (grid as HTMLElement).dataset.workAnimated = 'true';

    animateMini(
      grid.querySelectorAll('.work-card'),
      { opacity: [0, 1], transform: ['translateY(24px)', 'translateY(0)'] },
      { duration: 0.62, delay: stagger(0.08), ease: [0.16, 1, 0.3, 1] }
    );
  }, { margin: '0px 0px -18% 0px' });
}

function initConstellationPause() {
  const constellation = document.querySelector<HTMLElement>('[data-constellation], .constellation');
  if (!constellation) return;

  inView(constellation, () => {
    constellation.style.animationPlayState = 'running';
    return () => {
      constellation.style.animationPlayState = 'paused';
    };
  });
}

export function initAll() {
  initHeroEntrance();
  initSectionReveals();
  initStatsCounters();
  initWorkCardStagger();
  initConstellationPause();
}
